import { CommonModule } from '@angular/common';
import { Component, TemplateRef, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModalConfig, NgbOffcanvas, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AssessmentBulletinService } from '../../../../core/services/assessment-bulletin.service';
import { AssessmentService } from '../../../../core/services/assessment.service';
import { BulletinService } from '../../../../core/services/bulletin.service';
import { CompositionService } from '../../../../core/services/composition.service';
import { FileService } from '../../../../core/services/file.service';
import { NoteService } from '../../../../core/services/note.service';
import { PeriodService } from '../../../../core/services/period.service';
import { ProfessorAcademicClassroomService } from '../../../../core/services/professor-academic-classroom.service';
import { ProjectAyService } from '../../../../core/services/project-ay.service';
import { ReportSkillService } from '../../../../core/services/report-skill.service';
import { SkillService } from '../../../../core/services/skill.service';
import { StudentAyClassroomService } from '../../../../core/services/student-ay-classroom.service';
import { SubCourseService } from '../../../../core/services/sub-course.service';
import { AppErrorShow } from '../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../core/utils/app-sweet-alert';
import {FileService as myFileService} from '../../../../core/utils/file-service'
import { GlobalName } from '../../../../core/utils/global-name';
import { LocalStorageService } from '../../../../core/utils/local-stoarge-service';
import { SampleSearchPipe } from '../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../components/loading/loading.component';
import { HeaderComponent } from '../../../admin/layout/includes/header/header.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';


@Component({
    selector: 'app-follow-up',
    templateUrl: './follow-up.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule, NgxExtendedPdfViewerModule],
    styleUrls: ['./follow-up.component.css']
})
export class FollowUpComponent {

  buttonsPermission :any|undefined;
 search_text=""
  classrooms:any[] =[]
  roles:any[] =[]
  projects:any[] =[]
  data:any[] =[]
  notes:any[] =[]
  periods:any[] =[]
  compositions:any[] =[]
  courses:any[] =[]
  paccs:any[] =[]
  students:any[] =[]
  sanctions:any[] =[]
  pacs:any[] =[]
  selected_data:any;
  modalOption:any; 
  pacId:any; 
  paccId:any; 
  sacId:any; 
  sacInfo:any; 
  sbId:any; 
  periodId:any; 
  index:any; 
  currentCompositon:any; 
  isDtInitialized:boolean = false
  is_active=null
  loading=false
  tag="professors-follow-up"
  pg={
    pageSize:10,
    p:0,
    total:0
  }
  role:any
  user:any
  ab:any
  classroomId:any
  pdfViewLoader=false
  pdfSrc = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
  @ViewChild('contentPDF') contentPDF:TemplateRef<any> | undefined


  constructor(
    private spinnerService:NgxSpinnerService,
    private bulletinService:BulletinService,
    private noteService:NoteService,
    private fileService:FileService,
    private compService:CompositionService,
    private periodService:PeriodService,
    private sacService:StudentAyClassroomService,
    private pacService:ProfessorAcademicClassroomService,
    private subCourseService:SubCourseService,
    private skillService:SkillService,
    private abService:AssessmentBulletinService,
    private rsService:ReportSkillService,
    private payService:ProjectAyService,
    private assessmentService:AssessmentService,
    private router:Router,
    private toastrService:ToastrService,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
      private offcanvasService: NgbOffcanvas,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }


  ngOnInit(): void {
    this.init()
    this.getActions()
    this.sanctions=this.lsService.get(GlobalName.features).sanctions

  }

  init(){
    this.getProfessorAcademicClassrooms ()
    this.getPeriods()
  }

  getPeriods(){
    this.periodService.getByState(1).subscribe((res:any)=>{
      this.periods=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Suivi",err)
    })
  }

  open2(content:any,el:any){
    this.modalService.open(content)
    this.selected_data=el
  }

  loadCourses(event:any){
    this.courses=this.paccs.find((el:any)=>el.id==event.target.value).courses
  }

  getFile(code:any,folder:any,filename:any,css='details-panel'){
    this.spinnerService.show()
    this.pdfViewLoader=true
    this.fileService.get({
      folder:folder,
      code:code,
      filename:filename
    }).subscribe((res:any)=>{
      this.spinnerService.hide()
      this.pdfViewLoader=false
      this.pdfSrc=res[0]
      this.offcanvasService.open(this.contentPDF,{  panelClass: css, position: 'end'  });

    },
    (err:any)=>{
      this.spinnerService.hide()
      AppErrorShow.showError("Suivi",err)

    })
  }

  open(i:any){
    this.pdfSrc=this.data[i].motif_file
    this.offcanvasService.open(this.contentPDF,{  panelClass: 'details-panel', position: 'end'  });

  }
 

  getStudentAcademicClassroomList(classroomId:any){
    this.sacService.getAll(classroomId).subscribe((res:any)=>{
      res.data.forEach((element:any) => {
        this.data.push({
          id:element.id,
          code:element.student?.code,
          photo:element.photo,
          name:element.student?.firstname+" "+element.student?.lastname,
          value:0,
          isSetted:1,
          motif:"",
          motif_file:"",
          appreciation:"",
          hasFile:false
        })
      });
      
      this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Suivi",err)
    })
  }
  getProfessorAcademicClassrooms(){
    this.pacService.getProfessorAcademicClassrooms().subscribe((res:any)=>{
      this.pacs=res.data
      this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Suivi",err)
    })
  }
  getProfessorAcademicClassroomCourses(){
    console.log(this.pacId, this.periodId)
    if(this.periodId!=undefined && this.pacId!=undefined){
      this.pacService.getProfessorAcademicClassroomsCourses(this.pacId,this.periodId).subscribe((res:any)=>{
        this.courses=res.data[0].courses
        console.log( this.courses)
        this.modalService.dismissAll()
      },
      (err:any)=>{
      AppErrorShow.showError("Suivi",err)
      })
    }
  
  }
  loadCompositions1(event:any){
    this.pacId=this.courses.find((el:any)=>el.id==event.target.value).pivot?.id

    if (this.pacId != undefined && this.periodId!=undefined) {
      this.compService.getByCoursePeriod(this.pacId,this.periodId).subscribe((res:any)=>{
        this.compositions=res.data
      },
      (err:any)=>{
        AppErrorShow.showError("Suivi",err)

      })
    } 
   
  }
  loadProjectAy(ev:any){
    this.periodId=ev.target.value
    this.getProfessorAcademicClassroomCourses()
    this.payService.getByPeriod(this.periodId).subscribe((res:any)=>{
      this.projects=res.data
    },
    (err:any)=>{
      AppErrorShow.showError("Suivi",err)

    })
    if (this.sacId!=undefined && this.periodId!=undefined) {
      this.loading=true
      this.sacService.getFollowUp({
        period_id:this.periodId,
        sac_id:this.sacId,
        pac_id:this.pacId
      }).subscribe((res:any)=>{
        this.loading=false

        this.sacInfo=res.data
        this.index=res.index
      },
      (err:any)=>{
        this.loading=false

        AppErrorShow.showError("Suivi",err)
  
      })
    }
  }
  loadStudents(event:any){
    this.pacId=event.target.value;
    // let check=this.paccs.find((el:any)=>el.id==event.target.value)
    //   this.courses=check.courses
      this.getProfessorAcademicClassroomCourses()
      // this.courses.forEach((el:any, index:any)=> {
      //   this.subCourseService.getByPacc(this.pacId).
      //   getByPacc
      // })
      this.classroomId=this.pacs.find((el:any)=>el.id==event.target.value)?.classroom?.id
      this.sacService.getAll(this.classroomId).subscribe((res:any)=>{
        this.students=res.data
      },
      (err:any)=>{
        AppErrorShow.showError("Suivi",err)

      })
  }
  loadNotes(event:any){
      this.currentCompositon=this.compositions.find((el:any)=>el.id==event)
      this.spinnerService.show()
      this.noteService.getByComposition(event).subscribe((res:any)=>{
        this.spinnerService.hide()
        this.data=res.data
      },
      (err:any)=>{
        this.spinnerService.hide()
        AppErrorShow.showError("Suivi",err)

      })
  }


  resetNote(event:any, i:any){
      if(event.target.value=="0")this.data[i].value=0
      this.data[i].isSetted=event.target.value=="0"?0:1
  }


  async upload(ev:any, i:any){
    if (ev.target.files.length!=0) {
      this.data[i].motif_file=await myFileService.fromArrayBufferToBase64(await myFileService.readFileAsync(ev.target.files[0]))
      this.data[i].hasFile=true
    }
  }


  loadlist(e:any){
    this.getStudentAcademicClassroomList(e.target.value)
  }

  remove(i:any){
    this.data[i].motif_file=""
    this.data[i].hasFile=false  
  }


  store(value:any){
    this.loading=true
    console.log(this.data)
    this.noteService.store({
      composition_id:value.composition_id,
      notes:this.data
    }).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.modalService.dismissAll()
        

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Suivi",err)

    })
  }
  storeSubCourse(value:any){
    this.loading=true
    this.subCourseService.store({
      pacc_id:this.paccId,
      name:value.name
    }).subscribe((res:any)=>{
      this.loading=false
        this.toastrService.success(res.message)
        this.modalService.dismissAll()
        this.pacService.getProfessorAcademicClassroomsCourses(this.pacId,this.periodId).subscribe((res:any)=>{
          this.paccs=res.data
          let check=this.paccs.find((el:any)=>el.id==this.pacId)
          this.courses=check.courses
        },
        (err:any)=>{
        AppErrorShow.showError("Suivi",err)
        })
        

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Suivi",err)

    })
  }
  storeAssessment(value:any){
    this.loading=true
    this.assessmentService.store({
      period_id:this.periodId,
      sac_id:this.sacId,
      message:value.message
    }).subscribe((res:any)=>{
      this.loading=false
        this.toastrService.success(res.message)
        this.modalService.dismissAll()
        this.pacService.getProfessorAcademicClassroomsCourses(this.pacId,this.periodId).subscribe((res:any)=>{
          this.paccs=res.data
          let check=this.paccs.find((el:any)=>el.id==this.pacId)
          this.courses=check.courses
        },
        (err:any)=>{
        AppErrorShow.showError("Suivi",err)
        })
        

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Suivi",err)

    })
  }
  setSacId(ev:any){
    this.sacId=ev.target.value
    if (this.sacId!=undefined && this.periodId!=undefined) {
      this.verify()

      this.loading=true
      this.sacService.getFollowUp({
        period_id:this.periodId,
        sac_id:this.sacId,
        pac_id:this.pacId
      }).subscribe((res:any)=>{
        this.loading=false

        this.sacInfo=res.data
      },
      (err:any)=>{
        this.loading=false

        AppErrorShow.showError("Suivi",err)
  
      })
    }
    
  }
  storeLevelSkill(value:any){
    this.loading=true
    this.noteService.storeFollowUp(this.sacInfo).subscribe((res:any)=>{
      this.loading=false
        this.toastrService.success(res.message)
      
        this.getFollowUp()

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Suivi",err)

    })
  }
  storePay(value:any){
    this.loading=true
    this.payService.store({
      period_id:this.periodId,
      pac_id:this.pacId,
      title:value.title
    }).subscribe((res:any)=>{
      this.loading=false
        this.toastrService.success(res.message)
        this.modalService.dismissAll()
        this.payService.getByPeriod(this.periodId).subscribe((res:any)=>{
          this.projects=res.data
        },
        (err:any)=>{
          AppErrorShow.showError("Suivi",err)
    
        })
        // this.pacService.getProfessorAcademicClassroomsCourses().subscribe((res:any)=>{
        //   this.paccs=res.data
        //   let check=this.paccs.find((el:any)=>el.id==this.pacId)
        //   this.courses=check.courses
        // },
        // (err:any)=>{
        // AppErrorShow.showError("Suivi",err)
        // })
        

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Suivi",err)

    })
  }

  getFollowUp(){
    this.sacService.getFollowUp({
      period_id:this.periodId,
      sac_id:this.sacId,
      pac_id:this.pacId
    }).subscribe((res:any)=>{
      this.loading=false

      this.sacInfo=res.data
    },
    (err:any)=>{
      this.loading=false

      AppErrorShow.showError("Suivi",err)

    })
  }
  storeSkill(value:any){
    this.loading=true
    this.skillService.store({
      sub_course_id:this.sbId,
      pacc_id:this.paccId,
      pac_id:this.pacId,
      period_id:this.periodId,
      name:value.name
    }).subscribe((res:any)=>{
      this.loading=false
        this.toastrService.success(res.message)
        this.modalService.dismissAll()
        this.pacService.getProfessorAcademicClassroomsCourses(this.pacId,this.periodId).subscribe((res:any)=>{
          this.paccs=res.data
          let check=this.paccs.find((el:any)=>el.id==this.pacId)
          this.courses=check.courses
        },
        (err:any)=>{
        AppErrorShow.showError("Suivi",err)
        })
        

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Suivi",err)

    })
  }
  update(value:any){
    this.loading=true

    this.noteService.update(this.selected_data.id,value).subscribe((res:any)=>{
      this.loading=false
      this.modalService.dismissAll()
      this.data.find((el:any)=>el.id=this.selected_data.id).new_value=value.new_value

        this.toastrService.success(res.message)
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Suivi",err)

    })
  }
  delete(){
    if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.sacService.delete(this.selected_data.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
    },
    (err:any)=>{
      console.log(err)
        AppErrorShow.showError("Suivi",err)

    })
  }
})
  }
  confirm(){
    let confirmed=AppSweetAlert.confirmBox('success','Note de composition','Voulez vous vraiment confirmer les notes de cette composition élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
        this.spinnerService.show()
    this.compService.confirm(this.currentCompositon.id,1).subscribe((res:any)=>{
      this.spinnerService.hide()  
      this.toastrService.success(res.message)
      this.currentCompositon.is_confirmed=true
     // this.loadNotes(this.currentCompositon.id)
    },
    (err:any)=>{
      this.spinnerService.hide()

      console.log(err)
        AppErrorShow.showError("Suivi",err)

    })
  }
})
  }
  forAverage(state:any){
    let confirmed=AppSweetAlert.confirmBox('success','Note de composition','En tenir compte pour le calcul des moyennes de cet trimestre?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
        this.spinnerService.show()
    this.compService.forAverage(this.currentCompositon.id,state).subscribe((res:any)=>{
      this.spinnerService.hide()  
      this.toastrService.success(res.message)
      this.currentCompositon.for_average=state
      this.loadNotes(this.currentCompositon.id)
    },
    (err:any)=>{
      this.spinnerService.hide()

      console.log(err)
        AppErrorShow.showError("Suivi",err)

    })
  }
})
  }
  checked(el?:any){
    this.selected_data=el;
    this.is_active=el.is_active
  }
  verifyIfElementChecked(){
    console.log(this.selected_data)
    if (this.selected_data==null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }



  dismiss(){
    this.modalService.dismissAll()
  }

  add(content:any,paccId:any){
    this.paccId=paccId
    this.modalService.open(content,{size:'lg'});
  }
  add2(content:any,sbId:any){
    this.sbId=sbId
    this.modalService.open(content,{size:'lg'});
  }
  add3(content:any){
    this.modalService.open(content,{size:'lg'});
  }


  show(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalOption={centered:false,size:"lg"}
    this.modalService.open(content,{size:'lg'});
  }

  edit(){
   // if(!this.verifyIfElementChecked()) return ;
    this.router.navigate(["/professor-module/note-create/"+this.currentCompositon.id])

  }

  setStatus(value:any){

    this.toastrService.warning("Opération en cours")
  
        this.sacService.setState(this.selected_data.id,value).subscribe((res:any)=>{
          this.toastrService.success(res.message)
      },
      (err:any)=>{
        console.log(err)
          AppErrorShow.showError("Suivi",err)

      })
  }

  getActions(){
    // this.buttonsPermission = {
    //   show:AppActionCheck.check(this.tag,'Consultation'),
    //   add:AppActionCheck.check(this.tag,'ajout'),
    //   edit:AppActionCheck.check(this.tag,'edition'),
    //   delete:AppActionCheck.check(this.tag,'suppression'),
    //   status:AppActionCheck.check(this.tag,'statut')
    // };
    this.buttonsPermission={
      show:false,
      add:true,
      edit:true,
      delete:true,
      status:true,
    }
  }

  getTemplate(){
    this.bulletinService.getTemplateAssessment(this.classroomId,this.periodId).subscribe((res:any)=>{
      this.pdfViewLoader=false
      this.pdfSrc=res[0]
      this.offcanvasService.open(this.contentPDF,{  panelClass: 'details-panel', position: 'end'  });
  
       },
       (err:any)=>{
         AppErrorShow.showError("Gestion des bulletins",err)
  
       })
  }
  generateAssessmentBulletin(){
    this.bulletinService.generateAssessmentBulletin(this.classroomId,this.periodId,this.pacId,this.sacId).subscribe((res:any)=>{
      this.pdfViewLoader=false
      this.pdfSrc=res[0]
      this.offcanvasService.open(this.contentPDF,{  panelClass: 'details-panel', position: 'end'  });
  
       },
       (err:any)=>{
         AppErrorShow.showError("Gestion des bulletins",err)
  
       })
  }

  verify(){
    this.abService.verify(this.sacId,this.periodId).subscribe((res:any)=>{
        this.ab=res.data
       },
       (err:any)=>{
         AppErrorShow.showError("Gestion des bulletins",err)
  
       })
  }
}
